import React, { useState } from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";

import {
  Card,
  Button, Modal, ModalBody, Form, FormGroup, Label, Input, Row, Col,
  ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import avatar from '../../assets/images/users/3.jpg'
import Select, { components } from 'react-select'
import countryList from 'react-select-country-list'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { auth } from '../../Api'
import { Divider } from "antd";
import { personName } from '../../utils/people'
import { pickedToMoment, momentToPicked } from '../../utils/dutyTime'
import { leaveForm } from '../../utils/formReturn'
import EditButtons, { markChanged, withChange } from '../../components/forms/editButtons'
import { dutyFormValues, startHasPassed, saveConfirmation, REPLACES_DUTIES_NOTE } from '../../utils/dutyForm'
import { isPrivateAccount } from '../../utils/accountType'

class CompanyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      open: false,
      modal: false,
      obj: {},
      jsonData: data.dataTable,
      data: data.makeData(),
      treedata: data.treedata,
      options: countryList().getData(),
      nameValue: "",
      countryValue: null,
      center: {
        lat: 59.95,
        lng: 30.33
      },
      zoom: 11,
      startDate: new Date(),
      showAlert: false,
      showResult: false,
      durationList: [],
      minutesList: [],
      meterList: [],
      selectedDuration: {
        value: 12,
        label: "12 hours"
      },
      selectedMinute: {
        value: 10,
        label: "10"
      },
      clientLst: [],
      clientOption: null,
      locationLst: [],
      locationOption: null,
      
      guardOption: null,
      alertTemplateLst: [],
      alertTemplateOption: null,
      oldDuties: [],
      showExistAlert: false,
      hasDuty: false,
      guardId: 'null',
      rest_break: false,
      dutyData: {}
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      showAlert: !this.state.showAlert
    });
  }

  async componentDidMount() {
    let { id } = this.props.match.params
    let guardId = 'null'
    if (id.includes('g')) {
      guardId = id.replace("g", "")
      id = 'null'
    }
    console.log("guardID,id:", guardId, id)
    let companyId = localStorage.getItem('companyId')
    let { clientLst, alertTemplateLst, startDate } = this.state
    let tmpss = startDate
    startDate.setHours(tmpss.getHours() + 1, 0, 0, 0)
    let tmpNumberList = Array.from({ length: 12 }, (v, k) => k + 1)
    let tmpMinutesList = Array.from({ length: 6 }, (v, k) => k + 1)
    let tmpMeterList = Array.from({ length: 6 }, (v, k) => k + 1)
    let tmpDurations = []
    tmpNumberList.map((val) => {
      tmpDurations.push({
        value: val,
        label: val.toString() + " hours"
      })
    })
    var selectedMeter = {
      value: 10,
      label: "10"
    }
    var selectedMinute ={
      value: 10,
      label: "10"
    } 
    let tmpMinutes = []
    tmpMinutesList.map((val) => {
      tmpMinutes.push({
        value: val * 10,
        label: (val * 10).toString()
      })
    })
    let tmpMeters = []
    tmpMeterList.map((val) => {
      tmpMeters.push({
        value: val * 10,
        label: (val * 10).toString()
      })
    })

    this.setState({
      dutyId: id,
      guardId: guardId,
      startDate: startDate,
      company_id: companyId,
      durationList: tmpDurations,
      minutesList: tmpMinutes,
      meterList: tmpMeters,
      selectedMeter:selectedMeter,
      selectedMinute: selectedMinute
    })

    if (id != "null") {
      var req = {}
      req.id = id
      req.company_id = localStorage.getItem('companyId')
      await auth.getDuty(req)
        .then((res) => {
          console.log("duty------edit:", res)
          if (res.data.code != 200) {
            guardId = null
            return
          }
          let dutyData = res.data.message.users[0]
          guardId = dutyData.guard_id
          // The duty's own duration, rest break, max rest time and supervisor (not the new-duty values)
          const stored = dutyFormValues(dutyData)
          this.setState({
            dutyData:dutyData,
            selectedDuration: stored.selectedDuration,
            rest_break: stored.rest_break,
            selectedMinute: stored.selectedMinute,
            selectedMeter: stored.selectedMeter,
            supervisorId: stored.supervisorId,
            nameValue: dutyData.name,
            guardId: dutyData.guard_id,
            startDate: momentToPicked(dutyData.starttime, dutyData.timezone),
            clientOption: { value: dutyData.client_id, label: dutyData.client_name },
            locationOption: { value: dutyData.location_id, label: dutyData.location_name, timezone: dutyData.timezone },
            guardOption: { value: dutyData.guard_id, label: dutyData.guard_name },
            alertTemplateOption: { value: dutyData.alerttemplate_id, label: dutyData.alerttemplate_name, alert_time: dutyData.alert_time }
          })
        })
    }
    // Don't offer this company's clients for a guard or duty of another company (e.g. companyId left over from another tab)
    if (guardId != "null") {
      let guardRes = guardId ? await auth.getGuard({ id: guardId, company_id: companyId }) : null
      if (!guardRes || guardRes.data.code != 200) {
        this.setState({
          blocked: true,
          showAlert: true,
          showResult: false,
          alertMessage: 'This guard or duty does not belong to ' + (localStorage.getItem('companyName') || 'the company currently open') + '. Open its own company and try again.'
        })
        return
      }
      this.setState({
        guardData: guardRes.data.message.users
      })
    }
    var req = {}
    req.company_id = companyId
    auth.getClient(req)
      .then((res) => {
        clientLst = []
        if (res.data.code == 200) {
          res.data.message.users.forEach(element => {
            clientLst.push({ value: element.id.toString(), label: personName(element, 'client') })
          });
          this.setState({ clientLst })
          // A Private account: its one client is the owner, chosen without a word; the duty is at one of My locations
          if (isPrivateAccount() && clientLst.length > 0) {
            this.clientChange(clientLst[0])
          }
        }
      })

    var req = {}
    if (guardId != "null") {
      req.guard_id = guardId
    }
    auth.getAlertTemplate(req)
      .then((res) => {
        alertTemplateLst = []
        if (res.data.code == 200) {
          res.data.message.users.forEach(element => {
            alertTemplateLst.push({
              value: element.id.toString(),
              label: element.template_name,
              alert_time: element.alert_time
            })
          });
          this.setState({ alertTemplateLst })
        }
      })
  }

  clientChange = (e) => {
    let { locationLst } = this.state
    this.setState({
      clientOption: e,
    })
    console.log("e.distirct:", e);
    var client_id = e.value
    var req = {}
    req.client_id = client_id

    auth.getLocation(req)
      .then((res) => {
        locationLst = []
        if (res.data.code == 200) {
          res.data.message.users.forEach(element => {
            locationLst.push({ value: element.id, label: element.name, timezone: element.timezone })
          })
        }
        this.setState({ locationLst })
      })
  }

  handleChange = (event) => {
    console.log(["event.valu:", event.target.value, event.target.name])
    switch (event.target.name) {
      case "name":
        this.setState({
          nameValue: event.target.value
        })
        break;
    }
  }
  locationChange = (e) => {
    console.log("location:", e)
    this.setState({
      locationOption: e,
    })
  }
  guardChange = async (e) => {
    console.log("guard:", e)
    this.setState({
      guardOption: e,
    })
    var req = {}
    req.guard_id = e.value
    req.company_id = localStorage.getItem('companyId')
    var response = await auth.getGuardDuty(req)
    console.log("response of duty:", response.data.message.duty);
    if (response.data.message.duty)
      if (response.data.message.duty.length > 0)
        this.setState({ showExistAlert: true })
  }
  alertTemplateChange = (e) => {
    console.log("location:", e)
    this.setState({
      alertTemplateOption: e,
    })
  }
  setDurationChange = (e) => {
    this.setState({
      selectedDuration: e
    })
  }

  setMinutesChange = (e) => {
    console.log("e of min:", e)
    this.setState({
      selectedMinute: e
    })
  }

  setMeterChange = (e) => {
    console.log("e of min:", e)
    this.setState({
      selectedMeter: e
    })
  }

  onChange = (checked) => {
    console.log(`switch to ${checked}`);
    this.setState({
      rest_break: checked
    })
  };

  dateHandleChange = (value) => {
    console.log("startDate:", value)
    var date = value
    console.log("datemiliseconds:", date.getTime())
    var millisec = date.getTime();
    console.log("convertedDate:", new Date(millisec))
    value.setSeconds(0)
    console.log("startDate--setSeconds(0):", value)
    var date = value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate();
    var time = value.getHours() + ":" + value.getMinutes() + ":" + value.getSeconds();
    console.log(date, time);
    this.setState({ startDate: value })
  }

  // A new duty for a guard (not editing a duty): saving it replaces all the guard's current and future duties
  isNewForGuard() {
    const { dutyId, guardId } = this.state
    return String(dutyId) === "null" && guardId !== null && guardId !== undefined && String(guardId) !== "null"
  }

  // How many current or future duties the new duty replaces (laravel duty/replacedCount), or null when unknown
  replacedCount(guardId) {
    return auth.getReplacedCount({ guard_id: guardId })
      .then((res) => res.data.code == 200 && Number.isFinite(Number(res.data.count)) ? Number(res.data.count) : null)
      .catch(() => null)
  }

  // confirmed: Save (or "Save anyway") was pressed in the popup that asks first: a new duty that replaces the guard's
  // current and future duties, and/or a start time that has already passed
  onSave = async (event, confirmed = false) => {

    event.preventDefault();
    if (this.state.blocked) {
      this.setState({ showAlert: true })
      return
    }

    this.setState({ showResult: false });
    let { nameValue, clientOption, dutyId, guardId,
      company_id, locationOption, guardOption,
      startDate, alertTemplateOption, selectedDuration,
      rest_break, selectedMinute, selectedMeter,dutyData
    } = this.state

    Date.prototype.addMins = function (min) {
      this.setTime(this.getTime() + (min * 60 * 1000));
      return this;
    }
    var req = {}
    var duration = selectedDuration.value * 60
    req.name = nameValue
    req.duration = duration
    req.company_id = company_id
    if (clientOption != null) {
      req.client_id = clientOption.value
    }
    if (locationOption != null) {
      // The picked time is the location's clock time, with the location's summer time on that date
      // (not today's offset, which was wrong for a duty on the other side of a clock change)
      req.starttime = pickedToMoment(startDate, locationOption.timezone)
      req.endtime = req.starttime + duration * 60 * 1000

      req.location_id = locationOption.value
    }

    req.guard_id = guardId
    req.rest_break = rest_break
    req.rest_time = selectedMinute.value
    req.rest_meter = selectedMeter.value

    if (alertTemplateOption != null) {
      req.alerttemplate_id = alertTemplateOption.value
      req.alert_time = alertTemplateOption.alert_time
    }
    var that = this;
    let alertMessage = "";
    if (clientOption == null) {
      alertMessage = isPrivateAccount() ? 'Please add one of your locations first (My locations).' : 'Please select Client'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (locationOption == null) {
      alertMessage = isPrivateAccount() ? 'Please choose one of your locations.' : 'Please select location'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else if (alertTemplateOption == null) {
      alertMessage = 'Please select alert-template'
      that.setState({
        showAlert: true,
        showResult: false,
        alertMessage: alertMessage
      })
    }
    else {
      if(req.alert_time==45){
        if(selectedDuration.value%3!=0){
          alertMessage = '45 min intervals only works with Duration of 3,6,9 or 12 hours'
              that.setState({
                showAlert: true,
                showResult: true,
                alertMessage: alertMessage
              })
          return;
        }
      }
      if (!confirmed) {
        const replaceCount = this.isNewForGuard() ? await this.replacedCount(guardId) : 0
        const confirmation = saveConfirmation({ pastStart: startHasPassed(req.starttime), replaceCount })
        if (confirmation) {
          that.setState({ confirmation })
          return
        }
      }
      if (dutyId != "null") {
        req.id = Number(dutyId)
        req.duty_tid = dutyData.duty_tid
        // The form has no supervisor field: keep the duty's own (duty/update saves what is sent, none if nothing)
        if (this.state.supervisorId != null) {
          req.supervisor_id = this.state.supervisorId
        }
        auth.updateDuty(req)
          .then((res) => {
            if (res.data.code == 201) {
              // Back to the page the form was opened from, or the duty's page
              leaveForm(that.props.history, '/duty-detail/' + dutyId)
            }
            else if (res.data.code == 403 || res.data.code == 404) {
              that.setState({ showAlert: true, showResult: false, alertMessage: res.data.message.error })
            }
          })
      }
      else {
        auth.registerDuty(req)
          .then((res) => {
            console.log("auth.register's res:", res);
            if (res.data.message != null) {
              if (res.data.code == 400) {
                console.log("res.data.message.email:", res.data.message.email, res.data.message.email != null);
                if (res.data.message.name != null) {
                  alertMessage += 'The Duty-name already exists.\n'
                }
                if (res.data.message.phone != null) {
                  alertMessage += 'This phone number already exists\n'
                }
                console.log(["res.data.message:", res.data.message, alertMessage]);
                that.setState({
                  showAlert: true,
                  showResult: false,
                  alertMessage: alertMessage
                })
                console.log(["res.data.message:", alertMessage, that.state.alertMessage]);
              }
              else if (res.data.code == 201) {
                // Back to the page the form was opened from, or where the new duties are listed: the
                // guard's duties (one save may add a duty on several days, so there is no one duty page)
                leaveForm(that.props.history, req.guard_id && String(req.guard_id) !== "null" ? '/duty/' + req.guard_id : '/duty-location/' + locationOption.value)
              }
              else if (res.data.code == 403) {
                that.setState({ showAlert: true, showResult: false, alertMessage: res.data.message.error })
              }
            }
          });
      }
    }
    // event.preventDefault();
  }

  // Exit edit page / Discard changes: leaves without saving, back where the form was opened from (or the record's page)
  exitForm = () => {
    const id = this.props.match && this.props.match.params ? this.props.match.params.id : null
    leaveForm(this.props.history, ((id) => id && id !== 'null' && !String(id).startsWith('g') ? '/duty-detail/' + id : (String(id).startsWith('g') ? '/duty/' + String(id).slice(1) : '/guards'))(id))
  }

  render() {
    const { clientLst, clientOption, locationLst, locationOption,
      alertTemplateLst, alertTemplateOption,
      durationList, minutesList, meterList,
      selectedDuration, selectedMinute, selectedMeter, rest_break, confirmation } = this.state;
    const closeConfirmation = () => this.setState({ confirmation: null })

    return <div>
      <Card>
        <Row className="toolbar up-card-title">
          <div className="b-title"><i className="ti-map-alt mr-10"></i>&nbsp;Duty Information</div>
        </Row>
        {this.isNewForGuard() && <p className="replaces-duties-note text-muted mb-0 px-3 pt-2">{REPLACES_DUTIES_NOTE}</p>}
        <Row className="toolbar up-card-box justify-content-center">
          <form name="myForm" style={{ width: "100%" }} onSubmit={this.onSave} onChangeCapture={markChanged(this)}>
            <Row>
              <div className="col-lg-6 col-12">
                <Row className="company-text-area">
                  <label htmlFor="address" className="col-md-3 control-label">Alias</label>
                  <div className="col-md-9">
                    <input className="location-text-input" type="text" name="name" value={this.state.nameValue} onChange={withChange(this, this.handleChange)} required></input>
                  </div>
                </Row>
                
                {!isPrivateAccount() && <Row className="company-text-area">
                  <label className="col-md-3 control-label">Client</label>
                  <div className="col-md-9">
                    <Select name="district_id" options={clientLst} value={clientOption}
                      onChange={withChange(this, this.clientChange)} required />
                  </div>
                </Row>}
                <Row className="company-text-area">
                  <label htmlFor="address" className="col-md-3 control-label">{isPrivateAccount() ? 'My location' : 'Location'}</label>
                  <div className="col-md-9">
                    <Select name="district_id" options={locationLst} value={locationOption}
                      onChange={withChange(this, this.locationChange)} required
                      noOptionsMessage={() => isPrivateAccount() ? 'Add your locations first (My locations)' : 'No options'} />
                  </div>
                </Row>
                <div className="height-10"></div>
              </div>
              <div className="col-lg-6 col-12" style={{ marginTop: "auto", marginBottom: "auto" }}>
                <Row className="company-text-area">
                  <label htmlFor="address" className="col-lg-12 col-xl-3 control-label" >StartTime</label>
                  <div className="col-lg-12 col-xl-9">
                    <DatePicker
                      selected={this.state.startDate}
                      onChange={withChange(this, this.dateHandleChange)}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={30}
                      timeCaption="time"
                      dateFormat="MMMM d, yyyy h:mm aa"
                      className="datepicker"
                    />
                  </div>
                </Row>
                <Row className="company-text-area">
                  <label htmlFor="address" className="col-md-3 control-label">Alert Interval</label>
                  <div className="col-md-9">
                    <Select options={alertTemplateLst} value={alertTemplateOption} onChange={withChange(this, this.alertTemplateChange)}></Select>
                  </div>
                </Row>
                <Row className="company-text-area">
                  <label htmlFor="duration" className="col-md-3 control-label">Duration</label>
                  <div className="col-md-9">
                    <Select placeholder="Select duration" options={durationList} value={selectedDuration} onChange={withChange(this, this.setDurationChange)}></Select>
                  </div>
                </Row>
                <Divider/>
                <Row className="company-text-area">
                  <label htmlFor="address" className="col-md-6 control-label">Rest break ON/OFF</label>
                  <div className="col-md-6">
                    <Switch checked={rest_break} onChange={withChange(this, this.onChange)} />
                  </div>
                </Row>
                <Row className="company-text-area">
                  <label htmlFor="duration" className="col-md-6 control-label">Select max rest time (mins)</label>
                  <div className="col-md-6">
                    <Select placeholder="Select Minute" options={minutesList} value={selectedMinute} onChange={withChange(this, this.setMinutesChange)}></Select>
                  </div>
                </Row>
              </div>
              <div className="col-lg-6 col-12" style={{ marginTop: "auto", marginBottom: "auto" }}>
                
                {/* <Row className="company-text-area">
                  <label htmlFor="duration" className="col-md-7 control-label">Select length (m)</label>
                  <div className="col-md-5">
                    <Select placeholder="Select Length" options={meterList} value={selectedMeter} onChange={withChange(this, this.setMeterChange)}></Select>
                  </div>
                </Row> */}
              </div>
            </Row>
            <EditButtons changed={this.state.formChanged} onExit={this.exitForm} />
            <div className="height-10"></div>
          </form>

        </Row>
      </Card>
      <Modal isOpen={this.state.showAlert} toggle={this.toggle}>
        {/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
        <ModalBody className="alert-body">
          <i className="mdi mdi-alert-circle ft-60"></i>
          <h2>{this.state.alertMessage}</h2>
          <div className="height-10"></div>
          <FormGroup>
            <Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggle}>Cancel</Button>
            <span>&nbsp;&nbsp;</span>
            <Button color="primary" style={{ width: '100px' }} onClick={this.toggle}>Ok</Button>
          </FormGroup>
        </ModalBody>
      </Modal>
      {/* Asks before saving: the duties a new duty replaces, and/or a start time that has already passed (one popup) */}
      <Modal isOpen={!!confirmation} toggle={closeConfirmation}>
        <ModalBody className="alert-body">
          <i className="mdi mdi-alert-circle ft-60"></i>
          {(confirmation ? confirmation.messages : []).map((message) => <h2 key={message} className="save-confirm-message">{message}</h2>)}
          <div className="height-10"></div>
          <FormGroup>
            <Button color="secondary" className="ml-1" onClick={closeConfirmation}>Cancel</Button>
            <span>&nbsp;&nbsp;</span>
            <Button color="primary" onClick={() => { closeConfirmation(); this.onSave({ preventDefault() {} }, true) }}>{confirmation ? confirmation.button : 'Save'}</Button>
          </FormGroup>
        </ModalBody>
      </Modal>
    </div>
  }
}

export default CompanyView;
